import React, { useState } from 'react'
import "./Dashboard.css"
import Header from "../../Components/Header/Header" 
import Sidebar from "../../Components/Sidebar/Sidebar" 


export default function DashboardLayout({ children }) {


  // Add Active class heasder nd sidebar 
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive);
  };
  // Add Active class heasder nd sidebar 

  return (
    <section className="DashboardSec">
      <Header toggleSidebar={toggleSidebar} />
      <Sidebar isActive={isSidebarActive}/>
      <div className={`DashContent ${isSidebarActive ? "active" : ""}`} id='main'>
        {children}
      </div>

    </section>
  );
}
